import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=2a78e53a&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=2a78e53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a78e53a",
  null
  
)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseButton', component.exports)
}
export default component.exports